import * as ExcelJS from 'exceljs';

export const composeExcelBuffer = async (columns: Partial<ExcelJS.Column>[], rows: ExcelJS.RowValues[]) => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('1');

    sheet.columns = columns;

    const excelRows = sheet.addRows(rows);
    excelRows.forEach((row) => {
        // eslint-disable-next-line no-param-reassign
        row.alignment = { vertical: 'top', horizontal: 'left', wrapText: true };

        row.eachCell((cell) => {
            if (cell.hyperlink) {
                // eslint-disable-next-line no-param-reassign
                cell.font = {
                    underline: true,
                    color: { theme: 10 },
                };
            }
        });
    });

    const buffer = await workbook.xlsx.writeBuffer();

    return buffer;
};
